import { forwardRef } from 'react';
import Checkbox from '@mui/material/Checkbox';
import { ICCheckbox } from 'types/atoms';
import { ReactComponent as CheckboxSquareSvg } from 'assets/svg/checkbox-square.svg';
import { ReactComponent as CheckboxSquareCheckedSvg } from 'assets/svg/checkbox-square-checked.svg';
import { ReactComponent as CheckboxRoundedSvg } from 'assets/svg/checkbox-rounded.svg';
import { ReactComponent as CheckboxRoundedCheckedSvg } from 'assets/svg/checkbox-rounded-checked.svg';
import customTwMerge from 'utils/twMerge';

const CCheckbox = forwardRef<HTMLSpanElement, ICCheckbox>(
  ({ iconType, iconClassName, className, checkedClassName, ...rest }, ref) => {
    return (
      <Checkbox
        {...rest}
        className={customTwMerge('p-0 text-secondary-800', className)}
        classes={{
          checked: customTwMerge('!text-secondary-800', checkedClassName),
        }}
        icon={
          iconType === 'rounded' ? (
            <CheckboxRoundedSvg className={customTwMerge('h-5 w-5', iconClassName)} />
          ) : (
            <CheckboxSquareSvg className={customTwMerge('h-5 w-5', iconClassName)} />
          )
        }
        checkedIcon={
          iconType === 'rounded' ? (
            <CheckboxRoundedCheckedSvg className={customTwMerge('h-5 w-5', iconClassName)} />
          ) : (
            <CheckboxSquareCheckedSvg className={customTwMerge('h-5 w-5', iconClassName)} />
          )
        }
      />
    );
  }
);

export default CCheckbox;
